"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetValuesByDisplayNameIds = exports.useGetValueParamsByRegDeviceId = exports.useGetValueParamsByDisplayNameId = exports.useGetValueIdsByRegDeviceId = exports.useGetValueByRegDeviceId = exports.useGetUntTranslate = exports.useGetDeviceValues = exports.useGetDeviceValueByParams = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _react = require("react");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _function = require("../utils/function");
var _selectors = require("../redux/selectors");
var _constants = require("../utils/constants");
const useGetDeviceValues = _ref => {
  let {
    thingPDIDDevice = null
  } = _ref;
  return (0, _reactRedux.useSelector)((0, _selectors.selectDeviceValuesById)(thingPDIDDevice)) || {};
};
exports.useGetDeviceValues = useGetDeviceValues;
const useGetDeviceValueByParams = _ref2 => {
  let {
    thingPDIDDevice,
    displayNameId
  } = _ref2;
  return (0, _reactRedux.useSelector)((0, _selectors.selectDeviceValueByParams)(thingPDIDDevice, displayNameId)) || {};
};
exports.useGetDeviceValueByParams = useGetDeviceValueByParams;
const useGetValuesByDisplayNameIds = _ref3 => {
  let {
    displayNameIds = [],
    thingPDIDDevice
  } = _ref3;
  const values = useGetDeviceValues({
    thingPDIDDevice
  });
  const list = displayNameIds.reduce((acc, displayNameId) => values[displayNameId] ? [...acc, values[displayNameId]] : acc || {}, []);
  return (0, _react.useMemo)(() => list, [list]);
};
exports.useGetValuesByDisplayNameIds = useGetValuesByDisplayNameIds;
const useGetValueByRegDeviceId = _ref4 => {
  let {
    thingPDIDDevice = null,
    regular
  } = _ref4;
  const {
    displayNameId = []
  } = (0, _reactRedux.useSelector)((0, _selectors.selectDeviceById)(thingPDIDDevice)) || {};
  const values = useGetDeviceValues({
    thingPDIDDevice
  });
  const valueKey = (0, _react.useMemo)(() => displayNameId.find(key => regular === null || regular === void 0 ? void 0 : regular.test(key)) || {}, [displayNameId, regular]);
  return (0, _react.useMemo)(() => values[valueKey] || {}, [values[valueKey]]);
};
exports.useGetValueByRegDeviceId = useGetValueByRegDeviceId;
const useGetValueParamsByRegDeviceId = _ref5 => {
  let {
    thingPDIDDevice = null,
    regular,
    params = []
  } = _ref5;
  const valueObj = useGetValueByRegDeviceId({
    thingPDIDDevice,
    regular
  });
  const list = params.map(param => param === _constants.valueParamsName.value ? (0, _function.parseByValueType)(valueObj[param], valueObj.valueType) : valueObj[param]);
  return (0, _react.useMemo)(() => list, [list]);
};
exports.useGetValueParamsByRegDeviceId = useGetValueParamsByRegDeviceId;
const useGetValueParamsByDisplayNameId = _ref6 => {
  let {
    thingPDIDDevice = null,
    displayNameId,
    params = []
  } = _ref6;
  const valueObj = useGetDeviceValueByParams({
    thingPDIDDevice,
    displayNameId
  });
  const list = params.map(param => param === _constants.valueParamsName.value ? (0, _function.parseByValueType)(valueObj[param], valueObj.valueType) : valueObj[param]);
  return (0, _react.useMemo)(() => list, [list]);
};
exports.useGetValueParamsByDisplayNameId = useGetValueParamsByDisplayNameId;
const useGetValueIdsByRegDeviceId = _ref7 => {
  let {
    thingPDIDDevice = null,
    regular
  } = _ref7;
  const {
    displayNameId = []
  } = (0, _reactRedux.useSelector)((0, _selectors.selectDeviceById)(thingPDIDDevice), function () {
    let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return prev.displayNameId === next.displayNameId;
  }) || {};
  const valueKeys = displayNameId.filter(key => regular === null || regular === void 0 ? void 0 : regular.test(key)) || {};
  return (0, _react.useMemo)(() => valueKeys, [valueKeys]);
};
exports.useGetValueIdsByRegDeviceId = useGetValueIdsByRegDeviceId;
const useGetUntTranslate = _ref8 => {
  var _activeTranslations$D2;
  let {
    unit
  } = _ref8;
  const activeTranslations = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues);
  return (0, _react.useMemo)(() => {
    var _activeTranslations$D;
    return (activeTranslations === null || activeTranslations === void 0 || (_activeTranslations$D = activeTranslations.Default) === null || _activeTranslations$D === void 0 ? void 0 : _activeTranslations$D.unit[unit]) || '';
  }, [activeTranslations === null || activeTranslations === void 0 || (_activeTranslations$D2 = activeTranslations.Default) === null || _activeTranslations$D2 === void 0 ? void 0 : _activeTranslations$D2.unit, unit]);
};
exports.useGetUntTranslate = useGetUntTranslate;